import Vue from 'vue'

const state = {
  isVerifying: false
}

const actions = {
  SUBMIT: ({commit}, formData) => {
    commit('SET_IS_VERIFYING', true)
    Vue.http.post('campaign/', formData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_VERIFYING', false)
        if (!response.error) {
          console.log('success')
        }
      })
  }
}

const mutations = {
  SET_IS_VERIFYING: (state, status) => {
    state.isVerifying = status
  }
}

const getters = {
  getIsVerifying: state => {
    return state.isVerifying
  },
  isVerifyingButtonMessage: state => {
    return state.isVerifying ? 'message.scb.verifying' : 'message.scb.verify'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/scb.js